import { useState, useEffect } from 'react';
import { isConfigured, saveConfig } from './services/cw-api';
import SetupPane from './components/SetupPane';
import TaskPane from './components/TaskPane';
import LicenseBanner from './components/LicenseBanner';
import ErrorBoundary from './components/ErrorBoundary';
import { useLicense } from './hooks/useLicense';

function autoConfigFromEnv(): boolean {
  if (isConfigured()) {
    // Check if member is selected
    const config = JSON.parse(localStorage.getItem('cw_config') || '{}');
    return config.memberId > 0;
  }
  const auth = import.meta.env.VITE_CW_AUTH;
  const clientId = import.meta.env.VITE_CW_CLIENT_ID;
  const baseUrl = import.meta.env.VITE_CW_BASE_URL;
  if (auth && clientId && baseUrl) {
    saveConfig({ baseUrl, auth, clientId, memberId: 0 });
    // Return false — still need member selection
    return false;
  }
  return false;
}

export default function App() {
  const [configured, setConfigured] = useState(() => autoConfigFromEnv());
  // License check runs only after CW is configured — the hook needs the
  // companyId/memberId from cw_config to identify the tenant.
  const license = useLicense('oel');

  if (!configured) {
    return (
      <ErrorBoundary paneName="setup pane">
        <SetupPane onComplete={() => setConfigured(true)} />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary paneName="email logger">
      <LicenseBanner license={license}>
        <TaskPane onReset={() => setConfigured(false)} />
      </LicenseBanner>
    </ErrorBoundary>
  );
}
